export default {
  index: { method: 'get', url: 'algorithm/timetable/rules' },
  show: { method: 'get', url: 'algorithm/timetable/rules/{id}' },
  store: { method: 'post', url: 'algorithm/timetable/rules' },
  update: { method: 'put', url: 'algorithm/timetable/rules/{id}' },
  duplicate: { method: 'post', url: 'algorithm/timetable/rules/{id}/duplicate' },
  toggle: { method: 'post', url: 'algorithm/timetable/rules/{id}/toggle' },
  destroy: { method: 'delete', url: 'algorithm/timetable/rules/{id}' },
}
